import React, { useState } from 'react';
import { Droppable } from "react-beautiful-dnd";
import { useSelector } from 'react-redux';
import SGCard from './Card';
import ScoutForm from '../scout/scoutForm';
import { findSg } from '../utils';

const SGCards = (props) => {
    const { scoutGroupId } = props;
    const sgListById = useSelector((state) => state.scoutKanban.sgListById);
    const [openModal, setOpenModal] = useState(false);
    const scoutSearchText = useSelector((state) => state.scoutKanban.scoutSearchText);
    // if (!sgListById[scoutGroupId]) return <></>;
    return (
        !sgListById[scoutGroupId] ?
            <div className="kanban-column-add">
                <span onClick={() => setOpenModal(!openModal)}><i className="fa fa-plus-circle" />Add Field Group</span>
                {openModal && <ScoutForm show={openModal} onHide={() => setOpenModal(!openModal)} scoutGroupData={null} />}
            </div> : <Droppable key={scoutGroupId}
                disableInteractiveElementBlocking
                droppableId={scoutGroupId}
            // isDropDisabled={!isToday(search.range) || isRequesting}
            >
                {(provided, snapshot) => (
                    <div ref={provided.innerRef}
                        className={`kanban-column-body kanban-cards ${snapshot.isDraggingOver ? "dragging-over" : ""}`}
                    >
                        {/* {isRequesting && <div className="mt-4 w-100 text-center">Loading...</div>} */}
                        {sgListById[scoutGroupId]['scout_member_list'] && sgListById[scoutGroupId]['scout_member_list'].length > 0 && sgListById[scoutGroupId]['scout_member_list'].map((sm, index) => (
                            <SGCard
                                key={sm.scout_member_id}
                                index={index}
                                smId={sm.scout_member_id}
                                scoutGroupId={scoutGroupId}
                                sgItem={sm}
                                onFilter={e => findSg(e, { searchText: scoutSearchText }, null)}
                            />
                        ))}

                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
    );
}

export default SGCards;